<template>
  <div :class="$style.container">
    <div :class="$style.title">
      {{ $t('save.transaction.number') }}
    </div>

    <div :class="$style.subtitle">
      {{ payment.id }}
    </div>

    <div :class="$style.section">
      <div :class="$style.row">
        <div :class="$style.left">{{ $t('transaction.date') }}</div>
        <div :class="$style.right">{{ payment.date }}</div>
      </div>
       <div :class="$style.row">
        <div :class="$style.left">{{ $t('transaction.sum') }}</div>
        <div :class="$style.right">{{ payment.amount }}</div>
      </div>
      <div :class="$style.row">
        <div :class="$style.left">{{ $t('transaction.recipient') }}</div>
        <div :class="$style.right">
          <div>
            <base-link :href="recipient.project.url" target="_blank" rel="noopener nofollow">
              {{ recipient.project.name }}
            </base-link>
          </div>
          <div>
            <base-link :href="`mailto:${recipient.merchant.email}`">
              {{ recipient.merchant.email }}
            </base-link>
          </div>
        </div>
      </div>
    </div>

    <div :class="$style.footer">
      <div
        v-if="payment.subscription"
        :class="$style.subscription"
        @click="$router.push({ name: 'Subscription' })"
      >
        {{ $t('manage.subscription') }}
      </div>

      <receipt-sender
        :token="payment.processToken"
        :default-status="recipient.status"
      />
    </div>
  </div>
</template>

<script>
import BaseLink from 'atoms/base/BaseLink';
import ReceiptSender from 'organisms/receipt/ReceiptSender';

export default {
  name: 'PaymentView',
  components: {
    BaseLink,
    ReceiptSender,
  },
  props: {
    payment: {
      type: Object,
      required: true,
    },
    recipient: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +base-card

  .title
    +font-type(regular, 12, 16)
    margin-bottom: 10px

  .subtitle
    +font-type(regular, 24, 27)
    margin-bottom: 15px
    word-break: break-word

  .section
    +flexbox
    +flex-direction(column)

  .row
    +flexbox
    +font-type(regular, 12, 18)

    &:not(:last-child)
      margin-bottom: 15px

    .left, .right
      width: 50%

    .left
      color: rgba(33, 33, 33, 0.75)

  .footer
    margin: 15px -15px -15px
    box-shadow: 0px -1px 0px rgba(189, 189, 189, 0.5)

    +respond-to(medium)
      margin: 20px -20px -20px

  .subscription
    +panel-in-card
    +line-height(24)
    box-shadow: 0px 1px 0px rgba(189, 189, 189, 0.5)
    cursor: pointer

    +respond-to(medium)
      +font-size(16)
</style>
